import { Filter as Filter_kojaro } from './Filter.kojaro';
import { Filter as Filter_phosphor } from './Filter.phosphor';
import { Filter as Filter_zoomg } from './Filter.zoomg';
import { Filter as Filter_zoomit } from './Filter.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Filter_kojaro;

    case 'zoomg':
      return Filter_zoomg;

    case 'phosphor':
      return Filter_phosphor;

    default:
      return Filter_zoomit;
  }
};

export const Filter = IconRenderer();
